import { useEffect, useState, useRef } from 'react';
import throttle from 'lodash/throttle';
import type { ThrottleSettings } from 'lodash';

export function useThrottle<T>(value: T, wait: number = 500, options: ThrottleSettings = {}): T {
  const [throttledValue, setThrottledValue] = useState(value);
  const savedValue = useRef(value);

  useEffect(() => {
    savedValue.current = value;
    throttledHandler();
  }, [value]);

  const throttledHandler = useRef(
    throttle(
      () => {
        setThrottledValue(savedValue.current);
      },
      wait,
      options
    )
  ).current;

  useEffect(() => {
    return () => {
      throttledHandler.cancel();
    };
  }, [throttledHandler]);

  return throttledValue;
}
